export const getImportProspectRestrictionMsg = (
  importCount,
  remainingProspectLimit,
) => {
  const msg1 = `The file has ${importCount} prospects, but you can only import ${remainingProspectLimit} more prospects in your current plan.`;
  const msg2 = `You can choose to import the first ${remainingProspectLimit} prospects from the file or upgrade your account to import all the prospects.`;

  return [msg1, msg2];
};
